import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { UseFormRegisterReturn } from 'react-hook-form';  
import { Palette } from 'core/config';

interface Props 
{
    name          : string;
    label?        : string;
    initialValue? : boolean;
    setValue      : (name : string, value : any) => void;
    input         : UseFormRegisterReturn;
    showTerms?    : boolean;
}

export const Toggle : React.FunctionComponent<Props> = ({ 
    name,
    label, 
    initialValue,
    input,
    setValue,
    showTerms
}) => 
{
    const [ selected, setSelected ] = useState(initialValue ?? false);

    useEffect(() =>
    {
        setValue(name, initialValue ?? false);
    }, [ setValue ]);

    const onSelect = (noSelection : boolean) => 
    {
        return () => 
        {
            if (noSelection) 
            {
                if (selected) 
                {
                    setSelected(false);
                    setValue(name, false);
                }
            } 
            else 
            {
                if (!selected) 
                {
                    setSelected(true);
                    setValue(name, true);
                }
            }
        };
    };

    return (
        <Container>
            {label && <Label>{label}</Label>}
            <ToggleContainer>
                <ToggleOption selected={!selected} onClick={onSelect(true)}>NO</ToggleOption>
                <ToggleOption selected={selected} onClick={onSelect(false)}>YES</ToggleOption>
            </ToggleContainer>
            <HiddenInput {...input} />
            {showTerms && selected && (
                <Paragraph>
                    Since you have already made an offer, you will need to insert an assignment clause in order
                    for Manzil to facilitate the transaction; otherwise Manzil will not be able to fund your
                    mortgage. Please email us <a href="mailto:salaam@manzil.ca">salaam@manzil.ca</a> to speak 
                    with a representative once you have completed the application.
                </Paragraph>
            )}
        </Container>
    );
};

const Container = styled.div`
    margin-left: 60px;
    margin-right: 60px;
`;

const ToggleContainer = styled.div`
    display: flex;
    flex-direction: row;
    background-color: ${Palette.EGGSHELL_WHITE};
    width: 96px;
    border-radius: 9px;
`;

const ToggleOption = styled.div<{ selected : boolean; }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 51px;
    height: 30px;
    border-radius: 9px;
    font: normal normal normal 10px 'SofiaPro-Regular';
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;

    ${({ selected }) => (selected 
        ? `
            background-color: ${Palette.ORANGE};
            color: ${Palette.EGGSHELL_WHITE};
            box-shadow: -3px 1px 6px #0000004D;
            width: 51px;
        `
        : `
            background-color: ${Palette.EGGSHELL_WHITE};
            color: ${Palette.ORANGE};
            width: 45px;
        `
    )}
`;

const Label = styled.div`
    margin-top: 18px;
    margin-bottom: 8px;
    color: ${Palette.BLUE };
    font-size: 10px;
    font-family: 'SofiaPro-Regular';

    @media only screen and (min-width: 1300px) {
        font-size: 12px;
    }

    @media only screen and (min-width: 1900px) {
        font-size: 14px;
    }
`;

const HiddenInput = styled.input`
    position: absolute;
    visibility: hidden;
`;

const Paragraph = styled.p`
    padding-top: 6px;

    :first-child {
        padding-top: 15px;
    }

    font: normal normal normal 10px 'SofiaPro-Regular';
    color: ${Palette.BLUE};
    font-weight: 200;

    a {
        font: normal normal normal 10px 'SofiaPro-Bold';
    }

    @media only screen and (min-width: 600px) {
        font-size: 9px;

        span {
            font-size: 9px;
        }

        a {
            font-size: 9px;
        }
    }

    @media only screen and (min-width: 1300px) {
        font-size: 12px;

        span {
            font-size: 12px;
        }

        a {
            font-size: 12px;
        }
    }

    @media only screen and (min-width: 1900px) {
        font-size: 14px;

        span {
            font-size: 14px;
        }

        a {
            font-size: 14px;
        }
    }
`;